import AlarmTalkTemplateManagementContainer from './AlarmTalkTemplate/AlarmTalkTemplateManagementContainer';
import AlarmTalkSendContainer from './AlarmSend/AlarmTalkSendContainer';
import AlarmTalkListContainer from './AlarmTalkList/AlarmTalkListContainer';
export const AlarmTalkIndex = {
  AlarmTalkTemplateManagementContainer,
  AlarmTalkSendContainer,
  AlarmTalkListContainer,
};
